import widgets from "../../lib/widgets";
import { getContentByCategory, getLiveTvChannels, getLiveTvGroups } from "../../api/queries";
import { isSubscriptionActive } from "../../lib/utils";
import configs from "../../lib/configs";
import { LiveChannels } from "./LiveChannels";
import { MediaCategoryName } from "../../components/data-display/MediaCategoryName/MediaCategoryName";
import { ExternalApp } from "../../lib/models";

export default [
    {
        path: "livetv",
        component: LiveChannels,
        options: {
            clearHistory: true
        },
        on: (page: any) => {
            return new Promise<void>(async (resolve, reject) => {
                try {
                    // Use LiveTvGroups instead of individual channels
                    const liveTvGroups = await getLiveTvGroups(0);
                    // Pass groups directly to display with titles
                    page.groups = liveTvGroups;
                    resolve();
                } catch (e) {
                    console.log("ERROR loading live tv groups");
                }
            });
        },
        widgets: widgets,
        cache: 60 * 60 * 24,
        beforeNavigate: async () => {
            // Digicel live channels are free to watch (matching mobile); other
            // tenants still require an active subscription.
            if (configs.appId === "digicel") {
                return true;
            }
            if (!isSubscriptionActive()) {
                return "hoteltv-login";
            } else {
                return true;
            }
        }
    },
    {
        path: "category/:categoryId",
        component: MediaCategoryName,
        on: (page: any, { categoryId }: any) => {
            return new Promise<void>((resolve, reject) => {
                (async () => {
                    try {
                        if (categoryId === "apps" && window.Android?.getAppList) {
                            const apps = window.Android.getAppList();
                            page.data = {
                                id: "apps",
                                name: "Apps",
                                items: (typeof apps === "string" ? JSON.parse(apps) : apps).map((app: ExternalApp) => ({
                                    __typename: "ExternalApp",
                                    id: app.id,
                                    title: app.name,
                                    coverUrl: app.logo,
                                    backdropUrl: "",
                                    isFree: false
                                }))
                            };
                        } else {
                            page.data = await getContentByCategory(categoryId, 0, 72);
                        }
                        resolve();
                    } catch (e) {
                        reject(e);
                    }
                })();
            });
        },
        widgets: [
            <Lowercase<string>>"Menu",
            <Lowercase<string>>"Auth",
            <Lowercase<string>>"Subscription",
            <Lowercase<string>>"IAPSubscription",
            <Lowercase<string>>"PostTvSubscription",
            <Lowercase<string>>"Exit"
        ],
        cache: 60
    }
];
